import {MIS_RESELLER_REPORT_TABLE, MIS_RESELLER_REPORT_TABLE_EXPORT} from '../../Api/resources/endPoint';
import { serviceName } from '../../Api/resources/serviceConstants';

export const fetchResellerInvoice = (requestBody) => {
  return {
    url: MIS_RESELLER_REPORT_TABLE,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: requestBody,
    service: serviceName.PROJECT_MS,
  };
};

export const exportResellerInvoice = (requestBody) => {
  return {
    url: MIS_RESELLER_REPORT_TABLE_EXPORT,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: requestBody,
    service: serviceName.PROJECT_MS,
  };
};
